import { Ajax } from "./Utils/Ajax";

declare var tippy: any;
declare var panzoom: any;

const tippyInstances = tippy('path:not(.capa-negra)', {
    // content(reference) {
    //     const id = reference.getAttribute('data-template');
    //     if (id) {
    //         const template = document.getElementById(id);
    //         return template.innerHTML;
    //     }
    //     return "no content";
    // },
    animation: 'fade',
    arrow: true,
    placement: 'bottom',
    //followCursor: true,
    allowHTML: true,
    theme: 'light',
});

// just grab a DOM element
var element = document.querySelector('#mapa .vector')

// And pass it to panzoom
let instance = panzoom(element, {
    maxZoom: 3,
    minZoom: 1,
    bounds: true,
    boundsPadding: 1,
    zoomDoubleClickSpeed: 1,
});

// instance.on('transform', function () {
//     // This event will be called along with events above.
//     // console.log(instance.getTransform());
// });

let algojeje = function() {
    $(".vector path.casa").on("click touchend", function(){
        instance.pause();
        $("#mapa .modal .loader").show();
        $("#mapa .modal").fadeIn();
        let id = $(this).attr("id-casa");
        let ajaxService = new Ajax.Service();
        let ajaxOptions = new Ajax.Options(`get-datos-casa/${id}`, "get", {}, "json");
        ajaxService.request(ajaxOptions, function(response: any){
           $("#mapa .modelo-casa .modelo").text(response.modelo_casa);
           $("#mapa .imagen-casa img").attr("src", response.imagen_casa.full_route_file);
           $("#mapa .numero .numero-casa").text(response.id_publico_casa);
    
            let dispon = "";
            switch (response.estatus_casa) {
                case "No Disponible":
                    dispon = "no-disponible";
                    break;
                case "Disponible":
                    dispon = "disponible";
                    break;    
                case "Vendido":
                    dispon = "vendido";
                    break;
                case "Apartado":
                    dispon = "apartado";
                    break;
            }
    
            let $element = $("#mapa .disponibilidad").removeClass();
            $element.addClass(`disponibilidad ${dispon}`);
            $element.find(".estado").text(response.estatus_casa);
    
           $("#mapa .terreno .terreno-casa").text(response.metros_terreno_casa ? response.metros_terreno_casa : response.metros_terreno_modelo);
           $("#mapa .construccion .construccion-casa").text(response.metros_construccion_casa ? response.metros_construccion_casa : response.metros_construccion_modelo);
           $("#mapa .precio .precio-casa").text(response.precio_casa ? response.precio_casa : response.precio_modelo);

           $("#mapa .terreno-adicional .terreno-adicional-casa").text(response.terreno_adicional_casa);   
               
           if(response.terreno_adicional_casa == "No"){
                $("#mapa .precio-adicional").hide();
           }else{
                $("#mapa .precio-adicional").show();
           }
           $("#mapa .precio-adicional .precio-adicional-casa").text(response.precio_adicional_casa);
           $("#mapa .modal .loader").hide();
        }, function(response: any){
            instance.resume();
            instance.smoothZoomAbs(0.5, 0.5, 1);
            $("#mapa .modal").fadeOut();
        });
    });
}

$("#mapa .modal .container .close-modal").on("click", function(){
    instance.resume();
    instance.smoothZoomAbs(0.5, 0.5, 1);
    $("#mapa .modal").fadeOut();
});

algojeje();